import * as React from 'react';
import { RealtyType } from '../../components/RealtyType';

import { useDispatch, useSelector } from 'react-redux';

import { useApplicationContext } from '../../../common/utils/applicationContext';
import { getRegionWithoutCom } from '../../../common/utils/getRegionWithoutCom';
import { changeUrl } from '../../../common/utils/changeUrl';
import { selectFilters } from '../../../common/selectors/filters';
import { TThunkDispatch } from '../../../common/types/redux';
import { TRatingType } from '../../../common/types/filters';
import { setRatingType } from '../../../common/actions/filters/setRatingType';
import { realtyTypesData } from '../../../common/constants/realtyType';

export const RealtyTypeContainer: React.FC = () => {
  const { region, type } = useSelector(selectFilters);

  const dispatch = useDispatch<TThunkDispatch>();

  const { config } = useApplicationContext();

  const hasCommercialType = getRegionWithoutCom(config, region.slug);

  const handleType = React.useCallback(
    (newValue: TRatingType) => {
      changeUrl(newValue, region.slug);
      dispatch(setRatingType(newValue));
    },
    [dispatch, region],
  );

  return <RealtyType filterType={type} onChangeType={handleType} types={realtyTypesData} hasCom={hasCommercialType} />;
};
